import * as React from "react";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {AnnualPolicyInfo, ICustomerPortalService, Policy, ProductsEnum, Types} from "@falcon/services";
import {finalize, find, mergeMap} from "rxjs/operators";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {HomePolicySummaryPanel} from "../policySummary/HomePolicySummaryPanel";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";

interface IOldPolicySummaryPageParams {
    policyNumber: string;
    [key: string]: string | undefined;
}

interface IOldPolicySummaryPageState {
    loadingQueueSize: number;
    policy?: Policy;
}

@authorize
export class OldHomePolicySummaryPagePlain extends React.Component<IWithRouterProps<IOldPolicySummaryPageParams>, IOldPolicySummaryPageState> {
    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IOldPolicySummaryPageParams>) {
        super(props);

        this.state = {
            loadingQueueSize: 0,
        };
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Old Policies");

        this.incrementLoadingQueueSize(() => {
            this.customerPortalService
                .getExpiredPolicies(ProductsEnum.HOME)
                .pipe(
                    finalize(this.decrementLoadingQueueSize),
                    mergeMap(policies => policies),
                    find(policy => policy.policyNumber === this.props.params.policyNumber),
                )
                .subscribe(policy => {
                    this.customerPortalService.getAnnualPolicyInfo(policy!.policyNumber).subscribe((annualPolicyInfo: AnnualPolicyInfo) => {
                        policy!.annualPolicyInfo = annualPolicyInfo;
                        this.setState({ policy });
                    });
                });
        });
    }

    public render() {
        return (
            <>
                <FalconHeader />
                <Overlay show={this.isLoading()} />
                <div className="page-contents">
                    <AllianzOnlineBadge/>
                    {this.pluginTemplates.renderBackLink("Back", true, `/dashboard/annualHome/${this.props.params.policyNumber}`)}
                    <h1 className="page-heading-white">Policy summary</h1>
                    {!this.isLoading() && this.renderPolicy()}
                    {this.pluginTemplates.renderBackLink("Back", false, `/dashboard/annualHome/${this.props.params.policyNumber}`)}
                </div>
                <FalconFooter />
            </>
        );
    }

    private renderPolicy = () => {
        if (this.state.policy && !this.state.policy.annualPolicyInfo) {
            return null;
        }

        if (!this.state.policy) {
            return (
                <div className="panel">
                    <p className="m-0 font-weight-extra-light">Policy does not exist</p>
                </div>
            );
        }

        return (
            <HomePolicySummaryPanel
                policy={this.state.policy}
                navigate={this.props.navigate}
                policyNumber={this.props.params.policyNumber}/>
        );
    };

    private incrementLoadingQueueSize = (callback?: () => void) => {
        this.setState(
            {
                loadingQueueSize: this.state.loadingQueueSize + 1,
            },
            callback,
        );
    };

    private decrementLoadingQueueSize = (callback?: () => void) => {
        if (this.state.loadingQueueSize === 0) {
            return;
        }

        this.setState(
            {
                loadingQueueSize: this.state.loadingQueueSize - 1,
            },
            callback,
        );
    };

    private isLoading = () => {
        return this.state.loadingQueueSize !== 0;
    };
}

export const OldHomePolicySummaryPage = withRouter<{}, IOldPolicySummaryPageParams>(OldHomePolicySummaryPagePlain)
